import { i18n } from '@lingui/core'
import { Trans } from '@lingui/macro'
import { Divider, Grid, Typography } from '@mui/material'

export const FormProjectAffiliationsReadOnly = ({
  typeProps = {},
  title,
  value = [],
  connectedObject,
  langVersion,
  ...props
}) => {
  const { roles } = typeProps
  const roleToTrans = {}

  roles.forEach(role => {
    if (role.apiValue) {
      roleToTrans[role.apiValue] = role?.label?.portalTranslationId
        ? i18n._(role.label.portalTranslationId)
        : role?.label?.[langVersion]
    }
  })

  return (
    <div style={{ width: '100%' }}>
      <Grid container style={{ width: '100%' }}>
        <Grid item xs style={{ padding: 4 }}>
          <Typography className='form-print-subtitle'>
            <Trans>Contact name</Trans>
          </Typography>
        </Grid>
        <Grid item xs style={{ padding: 4 }}>
          <Typography className='form-print-subtitle'>
            <Trans>Contact e-mai</Trans>
          </Typography>
        </Grid>
        <Grid item xs style={{ padding: 4 }}>
          <Typography className='form-print-subtitle'>
            <Trans>Contact role</Trans>
          </Typography>
        </Grid>
      </Grid>
      {value.map((contact, index) => {
        return (
          <div key={index}>
            <Divider />
            <Grid container key={index} style={{ width: '100%' }}>
              <Grid item xs style={{ padding: 4 }}>
                <Typography className='form-read-only-text'>{contact.name}</Typography>
              </Grid>
              <Grid item xs style={{ padding: 4 }}>
                <Typography className='form-read-only-text'>{contact.email}</Typography>
              </Grid>
              <Grid item xs style={{ padding: 4 }}>
                <Typography className='form-read-only-text'>{roleToTrans[contact.role]}</Typography>
              </Grid>
            </Grid>
          </div>
        )
      })}
    </div>
  )
}
